import { useState, useEffect } from "react";
import AvailabilitySettings from "@/pages/AvailabilitySettings";
import { useProfileSettings } from "@/hooks/useProfileSettings";
import GeneralSettings from "./settings/GeneralSettings";
import BusinessSettings from "./settings/BusinessSettings";
import NotificationSettings from "./settings/NotificationSettings";
import SocialLinksSettings from "./settings/SocialLinksSettings";
import { SubscriptionSettings } from "./settings/SubscriptionSettings";
import { AdminSettings } from "./settings/AdminSettings";
import { useToast } from "@/hooks/use-toast";

interface SettingsTabProps {
  initialSection?: string;
  onSectionChange?: (section: string) => void;
}

const SettingsTab = ({ initialSection = "general", onSectionChange }: SettingsTabProps) => {
  const { toast } = useToast();
  const [selectedSection, setSelectedSection] = useState(initialSection);
  const { 
    profile, 
    loading, 
    connectingTelegram,
    connectionAttempted, 
    updateProfile, 
    connectTelegram 
  } = useProfileSettings();

  useEffect(() => {
    if (initialSection) {
      setSelectedSection(initialSection);
    }
  }, [initialSection]);

  const handleSectionChange = (value: string) => {
    setSelectedSection(value);
    
    if (onSectionChange) {
      onSectionChange(value);
    }
  };

  if (loading && !profile) {
    return (
      <div className="flex items-center justify-center h-96">
        <img 
          src="/lovable-uploads/f8714beb-a432-4da6-acab-3ef6f0a42367.png" 
          alt="Loading settings" 
          className="h-10 w-10 gebeya-spinner" 
        />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {selectedSection === "general" && (
        <GeneralSettings 
          profile={profile}
          loading={loading}
          connectingTelegram={connectingTelegram}
          connectionAttempted={connectionAttempted}
          onUpdate={updateProfile}
          onConnectTelegram={connectTelegram}
        />
      )}
      
      {selectedSection === "business" && (
        <BusinessSettings 
          profile={profile}
          loading={loading}
          onUpdate={updateProfile}
        />
      )}
      
      {selectedSection === "subscription" && (
        <SubscriptionSettings />
      )}
      
      {selectedSection === "notifications" && (
        <NotificationSettings />
      )}
      
      {selectedSection === "social-links" && (
        <SocialLinksSettings 
          profile={profile}
        />
      )}
      
      {selectedSection === "availability" && (
        <AvailabilitySettings />
      )}
      
      {selectedSection === "admin" && (
        <AdminSettings />
      )}
    </div>
  );
};

export default SettingsTab;
